export interface PasswordValidationResult {
  valid: boolean;
  errors: string[];
}

const PASSWORD_REQUIREMENTS: Array<{ label: string; test: (password: string) => boolean }> = [
  { label: 'Mínimo de 8 caracteres', test: (p) => p.length >= 8 },
  { label: 'Pelo menos 1 letra maiúscula', test: (p) => /[A-Z]/.test(p) },
  { label: 'Pelo menos 1 letra minúscula', test: (p) => /[a-z]/.test(p) },
  { label: 'Pelo menos 1 número', test: (p) => /[0-9]/.test(p) },
  { label: 'Pelo menos 1 caractere especial (!@#$%^&* etc.)', test: (p) => /[!@#$%^&*(),.?":{}|<>_\-+=]/.test(p) },
];

export function getPasswordRequirementStatus(password: string): Array<{ label: string; met: boolean }> {
  return PASSWORD_REQUIREMENTS.map((req) => ({
    label: req.label,
    met: req.test(password),
  }));
}

export function validateStrongPassword(password: string): PasswordValidationResult {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push('Mínimo de 8 caracteres');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('Pelo menos 1 letra maiúscula');
  }
  if (!/[a-z]/.test(password)) {
    errors.push('Pelo menos 1 letra minúscula');
  }
  if (!/[0-9]/.test(password)) {
    errors.push('Pelo menos 1 número');
  }
  if (!/[!@#$%^&*(),.?":{}|<>_\-+=]/.test(password)) {
    errors.push('Pelo menos 1 caractere especial (!@#$%^&* etc.)');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
